import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { hash, key } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || !window.history?.scrollRestoration) {
      return undefined;
    }

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    if (typeof window === "undefined" || hash) {
      return;
    }

    window.scrollTo({
      left: 0,
      top: 0,
      behavior: "auto",
    });
  }, [hash, key]);

  return null;
};

export default ScrollToTop;
